import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'durationFormat',
})
export class DurationFormatPipe implements PipeTransform {
    transform(value: number): string {
        if (value < 0) {
            return '00:00';
        }

        const minutes = Math.floor(value / 60);
        const seconds = Math.floor(value % 60);

        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

        return `${minutes}:${formattedSeconds}`;
    }
}
